/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom"
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import TagManager from 'react-gtm-module';
import $ from 'jquery';

function Caption0201() {
	let location = useLocation();
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);
	useEffect(() => {
		$(".contain_pop .btn_popup").click(function () {
			$(".popup").hide();
			var popData = $(this).attr('data');
			$(popData).show();
		});
		$(".btn_close").click(function () {
			$(".popup").hide();
		});
	}, [location])

	return (
		<>
			<div className="popup" id="tb_pop01">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="brand cb_29"></div>
								<p>i寶貝目前支援型號包含：ECONAVI智慧節能除濕機 F-Y45CXW、 變頻冷暖一對一冷氣空調-LJ系列 CS-LJ22YA2，更多詳細清單請至<a href="http://pmst.panasonic.com.tw/active/smartApp/PSPCindex.aspx" target="_blank" className="btn_link" rel="noreferrer">Panasonic官網</a>查看。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<div className="tit_thi">空調</div>
								<ul>
									<li><p><span>冷氣開啟(支援台語)</span></p></li>
									<li><p><span>冷氣關閉(支援台語)</span></p></li>
									<li><p><span>冷氣風速設定1~5段</span></p></li>
									<li><p><span>冷氣風速設定自動</span></p></li>
									<li><p><span>冷氣溫度調16~30度(支援台語)</span></p></li>
									<li><p><span>冷氣設為暖氣模式(冷氣、除濕、送風、自動、暖氣)</span></p></li>
									<li><p><span>冷氣開啟/關閉上下風</span></p></li>
									<li><p><span>冷氣開啟/關閉左右風</span></p></li>
									<li><p><span>詢問：冷氣現在狀態</span></p></li>
									<li><p><span>詢問：冷氣現在溫度設定多少</span></p></li>
								</ul>
								<div className="tit_thi">洗衣機</div>
								<ul>
									<li><p><span>洗衣機開始洗衣</span></p></li>
									<li><p><span>詢問：洗衣機還剩多久洗完？</span></p></li>
								</ul>
								<div className="tit_thi">除溼機</div>
								<ul>
									<li><p><span>除濕機開啟(支援台語)</span></p></li>
									<li><p><span>除濕機關閉(支援台語)</span></p></li>
									<li><p><span>除濕機切換成送風模式(自動、連續、乾衣、防霉、送風、乾燥、空氣清淨)</span></p></li>
									<li><p><span>除濕機濕度設定70(40、45、50、55、60、65、70)</span></p></li>
									<li><p><span>除濕機濕度多少 (等同詢問：除濕機現在濕度設定多少)</span></p></li>
									<li><p><span>詢問：除濕機現在狀態</span></p></li>
									<li><p><span>詢問：除濕機現在濕度設定多少</span></p></li>
								</ul>
								<div className="tit_thi">冰箱</div>
								<ul>
									<li><p><span>冰箱快速製冰開始</span></p></li>
									<li><p><span>冰箱快速製冰關閉</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="tb_pop02">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="brand cb_30"></div>
								<p>i寶貝支援LG ThinQ全系列智慧家電，包含「掃地機器人/空氣清淨機/除濕機/冷氣/電子衣櫥/乾衣機/冰箱/洗衣機」品類，更多詳細品類清單請至<a href="https://www.lg.com/tw/home-appliances" className="btn_link" target="_blank" rel="noreferrer">LG官網</a>查看</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<div className="tit_thi">掃地機器人</div>
								<ul>
									<li><p><span>開啟掃地機器人/關閉掃地機器人(支援台語)</span></p></li>
									<li><p><span>「暫停/充電」掃地機器人</span></p></li>
									<li><p><span>掃地機器人現在電量</span></p></li>
									<li><p><span>掃地機器人現在運轉模式</span></p></li>
								</ul>
								<div className="tit_thi">空氣清淨機</div>
								<ul>
									<li><p><span>開啟空氣清淨機/關閉空氣清淨機(支援台語)</span></p></li>
									<li><p><span>空氣清淨機風速設定為「1段」(2段、3段、4段、自動)</span></p></li>
									<li><p><span>空氣清淨機現在運轉模式</span></p></li>
									<li><p><span>空氣清淨機現在空氣品質</span></p></li>
								</ul>
								<div className="tit_thi">除濕機</div>
								<ul>
									<li><p><span>開啟除濕機/關閉除濕機(支援台語)</span></p></li>
									<li><p><span>除濕機風速設定為「1段」(2段)</span></p></li>
									<li><p><span>除濕機目前運轉模式</span></p></li>
									<li><p><span>除濕機室內濕度多少</span></p></li>
								</ul>
								<div className="tit_thi">冷氣</div>
								<ul>
									<li><p><span>開啟冷氣/關閉冷氣(支援台語)</span></p></li>
									<li><p><span>冷氣風速設定為「1段」(2段、3段、4段、自動)</span></p></li>
									<li><p><span>冷氣溫度設定為18-30度</span></p></li>
									<li><p><span>冷氣設為「除濕」模式(冷氣、送風、自動、暖氣)</span></p></li>
									<li><p><span>冷氣目前溫度設定/冷氣溫度設定幾度</span></p></li>
									<li><p><span>冷氣目前室內溫度/冷氣室內溫度幾度</span></p></li>
									<li><p><span>冷氣目前運轉模式</span></p></li>
								</ul>
								<div className="tit_thi">電子衣櫥</div>
								<ul>
									<li><p><span>「開啟/關閉/暫停」電子衣櫥</span></p></li>
									<li><p><span>電子衣櫥目前運轉模式</span></p></li>
									<li><p><span>電子衣櫥還剩多久洗完</span></p></li>
									<li><p><span>電子衣櫥遠端控制狀態</span></p></li>
								</ul>
								<div className="tit_thi">乾衣機</div>
								<ul>
									<li><p><span>「開啟/關閉/暫停」乾衣機</span></p></li>
									<li><p><span>乾衣機現在運轉模式</span></p></li>
									<li><p><span>乾衣機還剩多久烘完</span></p></li>
									<li><p><span>乾衣機遠端控制狀態</span></p></li>
								</ul>
								<div className="tit_thi">冰箱</div>
								<ul>
									<li><p><span>「開啟/關閉」冰箱急速冷凍</span></p></li>
								</ul>
								<div className="tit_thi">洗衣機</div>
								<ul>
									<li><p><span>「開啟/關閉/暫停」洗衣機</span></p></li>
									<li><p><span>洗衣機目前運轉模式</span></p></li>
									<li><p><span>洗衣機還剩多久洗完</span></p></li>
									<li><p><span>洗衣機遠端控制狀態</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="tb_pop03">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="brand cb_31"></div>
								<p>i寶貝目前支援「內建聯網模組之【除濕機/空氣清淨機/風扇/電鍋】品類」，型號包含：除濕機TDH-165MB-WI、 空氣清淨機TACR-1900PE-WI、風扇TF-L14DN-WI、電鍋TAC-06EA-WI，更多詳細清單請至<a href="http://smartliving.tatung.com.tw/" className="btn_link" target="_blank" rel="noreferrer">大同官網</a>查看。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<div className="tit_thi">空氣清淨機</div>
								<ul>
									<li><p><span>空氣清淨機開啟</span></p></li>
									<li><p><span>空氣清淨機關閉</span></p></li>
									<li><p><span>空氣清淨機切換成「自動」模式(一般、自動、睡眠)</span></p></li>
									<li><p><span>空氣清淨機空氣如何</span></p></li>
								</ul>
								<div className="tit_thi">風扇</div>
								<ul>
									<li><p><span>風扇開啟</span></p></li>
									<li><p><span>風扇關閉</span></p></li>
									<li><p><span>風扇切換成「一般」模式(一般、睡眠、自然)</span></p></li>
									<li><p><span>風扇風速調成「10段」 (1~12段)/風速加大/風速降低/風速最大/風速最低</span></p></li>
									<li><p><span>風扇擺頭開啟</span></p></li>
									<li><p><span>風扇擺頭關閉</span></p></li>
									<li><p><span>風扇現在模式</span></p></li>
								</ul>
								<div className="tit_thi">電鍋</div>
								<ul>
									<li><p><span>電鍋開啟</span></p></li>
									<li><p><span>電鍋關閉</span></p></li>
									<li><p><span>電鍋開啟烹煮</span></p></li>
									<li><p><span>電鍋開啟保溫</span></p></li>
									<li><p><span>電鍋切換成「快煮」模式(快煮、精煮、煲湯、糕點、加熱、湯粥、燉煮)</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="tb_pop04">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="brand cb_32"></div>
								<p>目前i寶貝僅支援艾法的Wi-Fi控制盒(i-Ctrl愛控)，操作流程請至<a href="https://aifatechnology.com/wp-content/uploads/i-Ctrl-%E8%89%BE%E6%8E%A7_WiFi-Control-Box_%E8%AA%AA%E6%98%8E%E6%9B%B8%E8%A9%B3%E7%B4%B0%E7%89%88.pdf" className="btn_link" target="_blank" rel="noreferrer">艾法說明書</a>查看。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<div className="tit_thi">冷氣</div>
								<ul>
									<li><p><span>客廳冷氣開啟/關閉</span></p></li>
									<li><p><span>客廳冷氣調高/調低</span></p></li>
									<li><p><span>客廳冷氣太冷了/太熱了</span></p></li>
									<li><p><span>客廳冷氣調升一度/調降一度</span></p></li>
								</ul>
								<div className="tit_thi">電視</div>
								<ul>
									<li><p><span>開啟/關閉電視</span></p></li>
									<li><p><span>客廳電視音量加大/音量降低</span></p></li>
									<li><p><span>客廳電視上一台/下一台/轉到第13台(數字可自由替換)</span></p></li>
									<li><p><span>客廳電視靜音/取消靜音</span></p></li>
								</ul>
								<div className="tit_thi">機上盒</div>
								<ul>
									<li><p><span>開啟/關閉機上盒</span></p></li>
									<li><p><span>客廳機上盒音量加大/音量降低</span></p></li>
									<li><p><span>客廳機上盒上一台/下一台/轉到第13台(數字可自由替換)</span></p></li>
									<li><p><span>客廳機上盒靜音/取消靜音</span></p></li>
								</ul>
								<div className="tit_thi">風扇</div>
								<ul>
									<li><p><span>客廳風扇開啟/關閉</span></p></li>
									<li><p><span>風扇風速加大/風速降低/風速最大/風速最低</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="tb_pop05">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="brand cb_39"></div>
								<p>i寶貝支援SiMPNiC設備型號，包含:智慧小精靈 Room Keeper(R1)、智慧插座 (SPG-US-SW)、智慧燈泡 (LED-02-SW)、智慧燈條 (SLS-01-SW)、智慧遙控器 (IRB-01-SW)等，更多資訊可至<a href="https://tw.simpnic.com/" className="btn_link" target="_blank" rel="noreferrer">SiMPNiC官網</a>查看。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<div className="tit_thi">電視</div>
								<ul>
									<li><p><span>打開客廳電視</span></p></li>
									<li><p><span>關閉客廳電視</span></p></li>
								</ul>
								<div className="tit_thi">冷氣</div>
								<ul>
									<li><p><span>打開父母房冷氣</span></p></li>
									<li><p><span>關閉父母房冷氣</span></p></li>
								</ul>
								<div className="tit_thi">風扇</div>
								<ul>
									<li><p><span>打開廚房風扇</span></p></li>
									<li><p><span>關閉廚房風扇</span></p></li>
								</ul>
								<div className="tit_thi">機上盒</div>
								<ul>
									<li><p><span>打開客廳機上盒</span></p></li>
									<li><p><span>關閉客廳機上盒</span></p></li>
								</ul>
								<div className="tit_thi">燈</div>
								<ul>
									<li><p><span>打開餐廳燈</span></p></li>
									<li><p><span>關閉餐廳燈</span></p></li>
									<li><p><span>餐廳燈亮度設定0~100</span></p></li>
									<li><p><span>餐廳燈變橘色</span></p></li>
								</ul>
								<div className="tit_thi"><span>插座</span><span style={{ "font-size": "8px" }}>(支援改名為：檯燈、小夜燈、燈、風扇、熱水瓶、飲水機、循環扇、電暖器等等)</span></div>
								<ul>
									<li><p><span>打開書房插座</span></p></li>
									<li><p><span>關閉書房插座</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="tb_pop06">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="brand cb_43"></div>
								<p>i寶貝支援禾聯智慧雲端空調系列，更多資訊可至<a href="https://www.heran.com.tw/" className="btn_link" target="_blank" rel="noreferrer">Heran官網</a>查看。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<div className="tit_thi">冷氣</div>
								<ul>
									<li><p><span>冷氣開啟(支援台語)</span></p></li>
									<li><p><span>冷氣關閉(支援台語)</span></p></li>
									<li><p><span>冷氣風速設定1~3段</span></p></li>
									<li><p><span>冷氣風速設定自動</span></p></li>
									<li><p><span>冷氣溫度調16~30度</span></p></li>
									<li><p><span>冷氣設為暖氣模式(冷氣、除濕、送風、暖氣)</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="content_inpage">
				<div className="pagesize">
					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/caption">服務說明</a></li>
						<li><a href="/container/caption/Caption0201">家電清單說明</a></li>
					</ul>
					<h2 className="tit_main">家電清單說明</h2>
					<div className="content_box">
						<div className="table_box show_web contain_pop">
							<table border="0" cellpadding="0" cellspacing="0">
								<tr>
									<th width="20%">服務品牌</th>
									<th>服務說明</th>
									<th>例句</th>
								</tr>
								<tr className="btn_popup" data="#tb_pop01">
									<td><div className="brand cb_29"></div></td>
									<td className="txt_left">搭配國際牌小幫手，讓您輕鬆控制家裡的Panasonic電器設備。</td>
									<td>
										<div className="cb_dialog">
											<ul>
												<li><p className="flex_set"><span>i寶貝，冷氣開啟 ( 支援台語 )。</span></p></li>
												<li><p className="flex_set"><span>i寶貝，將空調設為冷氣模式。</span></p></li>
											</ul>
										</div>
									</td>
								</tr>
								<tr className="btn_popup" data="#tb_pop02">
									<td><div className="brand cb_30"></div></td>
									<td className="txt_left">透過i寶貝輕鬆聲控LG智慧家電，讓您不論在家或外出都能隨時遠端操控全家電！</td>
									<td>
										<div className="cb_dialog">
											<ul>
												<li><p className="flex_set"><span>i寶貝，風扇調為強。</span></p></li>
												<li><p className="flex_set"><span>i寶貝，開啟空氣清淨機。</span></p></li>
											</ul>
										</div>
									</td>
								</tr>
								<tr className="btn_popup" data="#tb_pop03">
									<td><div className="brand cb_31"></div></td>
									<td className="txt_left">透過i寶貝輕鬆聲控大同智慧家電，讓您即刻體驗未來智慧生活！</td>
									<td>
										<div className="cb_dialog">
											<ul>
												<li><p className="flex_set"><span>i寶貝，開啟電鍋。</span></p></li>
												<li><p className="flex_set"><span>i寶貝，電鍋開啟保溫。</span></p></li>
											</ul>
										</div>
									</td>
								</tr>
								<tr className="btn_popup" data="#tb_pop04">
									<td><div className="brand cb_32"></div></td>
									<td className="txt_left">透過i寶貝輕鬆聲控艾法紅外線，直接掌控家中大小設備！</td>
									<td>
										<div className="cb_dialog">
											<ul>
												<li><p className="flex_set"><span>i寶貝，客廳冷氣開啟/關閉。</span></p></li>
												<li><p className="flex_set"><span>i寶貝，客廳冷氣調高/調低。</span></p></li>
											</ul>
										</div>
									</td>
								</tr>
								<tr className="btn_popup" data="#tb_pop05">
									<td><div className="brand cb_39"></div></td>
									<td className="txt_left">透過i寶貝輕鬆聲控SiMPNiC設備，用創意變出家的樂趣！</td>
									<td>
										<div className="cb_dialog">
											<ul>
												<li><p className="flex_set"><span>i寶貝，打開客廳燈。</span></p></li>
												<li><p className="flex_set"><span>i寶貝，關閉客廳燈。</span></p></li>
											</ul>
										</div>
									</td>
								</tr>
								<tr className="btn_popup" data="#tb_pop06">
									<td><div className="brand cb_43"></div></td>
									<td className="txt_left">搭配禾聯IoT，讓您輕鬆控制家裡的禾聯電器設備。</td>
									<td>
										<div className="cb_dialog">
											<ul>
												<li><p className="flex_set"><span>i寶貝，冷氣開啟(支援台語)。</span></p></li>
												<li><p className="flex_set"><span>i寶貝，冷氣風速設定1~3段。</span></p></li>
											</ul>
										</div>
									</td>
								</tr>
							</table>
						</div>
						<div className="list_box show_mobile contain_pop">
							<div className="lb_cell btn_popup" data="#tb_pop01">
								<div className="caption_txt">
									<div className="cb_type">
										<div className="brand cb_29"></div>
										<p>透過i寶貝輕鬆聲控Panasonic智慧家電，讓您輕鬆升級智慧生活！</p>
									</div>
									<div className="cb_dialog">
										<ul>
											<li><p><span>i寶貝，冷氣開啟 ( 支援台語 )。</span></p></li>
											<li><p><span>i寶貝，將空調設為冷氣模式。</span></p></li>
										</ul>
									</div>
								</div>
							</div>
							<div className="lb_cell btn_popup" data="#tb_pop02">
								<div className="caption_txt">
									<div className="cb_type">
										<div className="brand cb_30"></div>
										<p>透過i寶貝輕鬆聲控LG智慧家電，讓您不論在家或外出都能隨時遠端操控全家電！</p>
									</div>
									<div className="cb_dialog">
										<ul>
											<li><p><span>i寶貝，風扇調為強。</span></p></li>
											<li><p><span>i寶貝，開啟空氣清淨機。</span></p></li>
										</ul>
									</div>
								</div>
							</div>
							<div className="lb_cell btn_popup" data="#tb_pop03">
								<div className="caption_txt">
									<div className="cb_type">
										<div className="brand cb_31"></div>
										<p>透過i寶貝輕鬆聲控大同智慧家電，讓您即刻體驗未來智慧生活！</p>
									</div>
									<div className="cb_dialog">
										<ul>
											<li><p><span>i寶貝，開啟電鍋。</span></p></li>
											<li><p><span>i寶貝，電鍋開啟保溫。</span></p></li>
										</ul>
									</div>
								</div>
							</div>
							<div className="lb_cell btn_popup" data="#tb_pop04">
								<div className="caption_txt">
									<div className="cb_type">
										<div className="brand cb_32"></div>
										<p>透過i寶貝輕鬆聲控艾法紅外線，直接掌控家中大小設備！</p>
									</div>
									<div className="cb_dialog">
										<ul>
											<li><p><span>客廳冷氣開啟/關閉</span></p></li>
											<li><p><span>客廳冷氣調高/調低</span></p></li>
										</ul>
									</div>
								</div>
							</div>
							<div className="lb_cell btn_popup" data="#tb_pop05">
								<div className="caption_txt">
									<div className="cb_type">
										<div className="brand cb_39"></div>
										<p>透過i寶貝輕鬆聲控SiMPNiC設備，用創意變出家的樂趣！</p>
									</div>
									<div className="cb_dialog">
										<ul>
											<li><p><span>i寶貝，打開客廳燈。</span></p></li>
											<li><p><span>i寶貝，關閉客廳燈。</span></p></li>
										</ul>
									</div>
								</div>
							</div>
							<div className="lb_cell btn_popup" data="#tb_pop06">
								<div className="caption_txt">
									<div className="cb_type">
										<div className="brand cb_43"></div>
										<p>搭配禾聯IoT，讓您輕鬆控制家裡的禾聯電器設備。</p>
									</div>
									<div className="cb_dialog">
										<ul>
											<li><p><span>i寶貝，冷氣開啟(支援台語)。</span></p></li>
											<li><p><span>i寶貝，冷氣風速設定1~3段。</span></p></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Caption0201;